import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import textStyle from '../P/textStyle';

const iconColors = ['blue', 'orange', 'green'];
const ButtonWrapper = styled(Button)`
  background: ${props => props.theme.colors.white};
  display: flex;
  justify-content: flex-start;
  height: 50px;
  align-items: center;
  ${props => props.gray && css`background: #f4f5f7;`};
`;
const ButtonText = styled.span`
  ${textStyle};
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  text-align: left;

  span {
    font-family: ${props => props.theme.fonts.fontface};
  }
`;
const InfoText = styled.span`
  ${textStyle} display: flex;
  align-items: center;
  padding: 5px 20px;
`;
const StatusWrapper = styled.div`
  background: ${props => props.theme.colors[props.statusColor]};
  width: 50px;
  height: 50px;
  flex: 0 0 50px;
  display: flex;
  align-items: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  text-align: center;

  svg {
    width: 100%;
    height: 30px;
  }
`;

class ListIconButton extends React.Component {
  render() {
    const {
      statusColor,
      statusIcon,
      label,
      info,
      onClick,
      extraLabel
    } = this.props;
    return (
      <ButtonWrapper rounded full onClick={onClick} {...this.props}>
        <StatusWrapper statusColor={statusColor}>
          <Icon id={statusIcon} />
        </StatusWrapper>
        <ButtonText bold>
          {label}
          <span>&nbsp;{extraLabel}</span>
        </ButtonText>
        {info && <InfoText italic>{info}</InfoText>}
      </ButtonWrapper>
    );
  }
}

ListIconButton.propTypes = {
  onClick: PropTypes.func,
  statusColor: PropTypes.oneOf(iconColors),
  icon: PropTypes.string,
  label: PropTypes.string,
  extraLabel: PropTypes.string
};

ListIconButton.defaultProps = {
  statusColor: iconColors[0]
};

export default ListIconButton;
